module.exports = __webpack_public_path__ + "img/concert_cn.59ba979e.png";